@if (readonly()) {
  <div class="grid template-cols-36 gap-24 client-invoice-draft-item">
    <div class="g-col-1 k-d-flex k-align-items-center" style="width: 32px;"></div>

    <div class="g-col-5 k-d-flex k-align-items-center">
      {{ clientInvoiceItem().articleNumber }}
    </div>

    <div class="g-col-6 k-d-flex k-align-items-center">
      {{ clientInvoiceItem().typeNumber }}
    </div>

    <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().retailPrice | kendoNumber: decimalFormat }}
    </div>

    <div class="g-col-2 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().vatPercentage | percentage }}
    </div>

    <div class="g-col-3 k-d-flex k-align-items-center k-justify-content-end pe-12">
      {{ clientInvoiceItem().amount | kendoNumber: amountFormat }}
    </div>

    <div class="g-col-2 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().taxPrice | kendoNumber: decimalFormat }}
    </div>

    <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().basicNetPrice | kendoNumber: decimalFormat }}
    </div>

    <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-start">
      {{ clientInvoiceItem().conditionString }}
    </div>

    <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().purchasePrice | kendoNumber: decimalFormat }}
    </div>

    <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().lineTotal | kendoNumber: decimalFormat }}
    </div>
  </div>
} @else {
  <div [formGroup]="clientInvoiceItemForm" class="grid template-cols-36 gap-24 client-invoice-draft-item">
    <div class="g-col-1 k-d-flex k-align-items-center" style="width: 42px;"></div>

    <div class="g-col-4 k-d-flex k-align-items-center">
      {{ clientInvoiceItem().articleNumber }}
    </div>

    <div class="g-col-6 k-d-flex k-align-items-center">
      {{ clientInvoiceItem().typeNumber }}
    </div>

    <div class="g-col-3">
      <kendo-numerictextbox
        rcValidation
        [format]="decimalFormat"
        [decimals]="2"
        [spinners]="false"
        [changeValueOnScroll]="false"
        formControlName="retailPrice"
(blur)="onFieldBlur('retailPrice')"></kendo-numerictextbox>
    </div>

    <div class="g-col-2 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().vatPercentage | percentage }}
    </div>

    <div class="g-col-3">
      <kendo-numerictextbox
        rcValidation
        [format]="amountFormat"
        [decimals]="amountDecimals"
        [spinners]="false"
        [changeValueOnScroll]="false"
        formControlName="amount"
(blur)="onFieldBlur('amount')"></kendo-numerictextbox>
    </div>

    <div class="g-col-3">
      <kendo-numerictextbox
        rcValidation
        [format]="decimalFormat"
        [decimals]="2"
        [spinners]="false"
        [changeValueOnScroll]="false"
        formControlName="taxPrice"
        (blur)="onFieldBlur('taxPrice')"></kendo-numerictextbox>
    </div>

    <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().basicNetPrice | kendoNumber: decimalFormat }}
    </div>

    <div class="g-col-3">
      <kendo-textbox
        rcValidation
        formControlName="conditionString"
(blur)="onFieldBlur('conditionString')"></kendo-textbox>
    </div>

    <div class="g-col-3">
      <kendo-numerictextbox
        rcValidation
        [format]="decimalFormat"
        [decimals]="2"
        [spinners]="false"
        [changeValueOnScroll]="false"
        formControlName="purchasePrice"
(blur)="onFieldBlur('purchasePrice')"></kendo-numerictextbox>
    </div>

    <div class="g-col-4 k-d-flex k-align-items-center k-justify-content-end">
      {{ clientInvoiceItem().lineTotal | kendoNumber: decimalFormat }}
    </div>
  </div>
}
